import autoSchedulingPatchesModule from '../../autoScheduling';
import Links from '../../controllers/links';

export default instance => {
  instance.attachEvent('onBeforeLinkAdd', (id, link) => Links.onBeforeLinkAdd(id, link));
  instance.attachEvent('onBeforeLinkAdd', (id, link) => autoSchedulingPatchesModule.preventLinkFromEmptyProject(id, link));
  instance.attachEvent('onBeforeLinkAdd', (id, link) => autoSchedulingPatchesModule.preventLinkByLimits(id, link));
};
